import { ProjectImage,
    ProjectImageContainer,
    StyledArrowLeft, 
    StyledArrowRight } from "../../styles/MyProject.styled";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import { SliderContainer } from "../../styles/Global.styled";


const NextArrow = ({ onClick }) => (
  <StyledArrowRight onClick={onClick}>➡</StyledArrowRight>
);

const PrevArrow = ({ onClick }) => (
  <StyledArrowLeft onClick={onClick}>⬅</StyledArrowLeft>
);



export const ImageSlider = ({ images,vistaPrevia }) => {
  const settings = {
        dots: true,
        infinite: false,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        nextArrow: <NextArrow />,  // Asignar flecha siguiente
        prevArrow: <PrevArrow />,  // Asignar flecha anterior
        appendDots: dots => (

   <div style={{ position: "absolute", bottom: "-2vh", left: "50%", transform: "translateX(-50%)", width: "100%"
   }}>
      <ul style={{ margin: "0px", padding: "0px", display: "flex", justifyContent: "center",zIndex:'100' }}> {dots} </ul>
    </div>
  ),};
  
  return (
  
    <Slider {...settings} >
      {images.map((img, index) => (
        <ProjectImageContainer key={index}>
          <ProjectImage src={img} alt={`Project ${index}`} />
        </ProjectImageContainer>
      ))}
    </Slider>
    

  );
};

